// extracted by mini-css-extract-plugin
export default {"patient-notes":"Notes_patient-notes__P6goh","patient-notes-textbox":"Notes_patient-notes-textbox__GPNOI"};